export const MEDIA_TYPES = {
  image: 'image',
  video: 'video',
}
export const isTypeImage = type => type === MEDIA_TYPES.image
export const isTypeVideo = type => type === MEDIA_TYPES.video
